export const CHANGE_LANGUAGE = 'change_language';
export const CHANGE_RESUME_LANGUAGE = 'change_resume_language';
